import React  ,{ useState }  from "react";
import { useSelector } from "react-redux";

import Besoins from "./Besoins";
import FiltresCompagniesTarifs from "../../Components/FiltresCompagniesTarifs";
import DateAdhesion from "../../Components/DateAdhesion/DateAdhesion";


import './GroupFiltres.scss';

function GroupFiltres({dispfiltrebesoins, setDispfiltrebesoins}){
    const [dispfiltrecomp, setDispfiltrecomp ] = useState(false) ;
    const idsNeeds= useSelector(state=>state.formules.idsNeeds) ;
    const formules = useSelector(state=>state.formules.datas);
    const listecompagniesaffichees =  useSelector(state=>state.formules.listecompagniesaffichees);
    const formulesbycompagniesandneeds = formules.filter(x=>listecompagniesaffichees.indexOf(x.compagnie)!==-1 && idsNeeds?.includes(x.id)).sort((a,b)=>a.prix-b.prix) ; 

const clickbtnbesoins = ()=>{

    setTimeout(()=>{
        const divformules = document.getElementById('divformules')?.getBoundingClientRect()?.top ;
        const divform= document.getElementById(formulesbycompagniesandneeds?.[0]?.id)?.getBoundingClientRect()?.top ;
        if(dispfiltrebesoins && formulesbycompagniesandneeds?.[0]){
            document.getElementById('divformules').scrollTo({top:divform - divformules -150 ,behavior:"smooth"})
            }
    },500)

    
    // const element = document.getElementById(formulesbycompagniesandneeds?.[0]?.id);
    // if (element && dispfiltrebesoins) { element.scrollIntoView({ behavior: 'smooth' }); }

    setDispfiltrebesoins(!dispfiltrebesoins);

}
  
    return(<div className="container_filtresformules">

                <div className="filtresformules" >
                    <div  className="filtresformules_datedisplays">
                        <DateAdhesion formulaire={false} setDispfiltrecomp={setDispfiltrecomp} dispfiltrecomp={dispfiltrecomp} dispfiltrebesoins={dispfiltrebesoins} setDispfiltrebesoins={setDispfiltrebesoins}  />  
                        <div>
                            <button className="openclosefiltres first" onClick={()=>{setDispfiltrecomp(!dispfiltrecomp)}} >Compagnies</button>
                            <button  className="openclosefiltres" onClick={clickbtnbesoins}>Besoins</button>
                        </div>
                    </div>

                    { dispfiltrecomp   &&  <FiltresCompagniesTarifs    /> }
                    {dispfiltrebesoins &&   <Besoins   />    }
                </div>

            </div>)
}


export default GroupFiltres;

